export default __webpack_public_path__ + "static/media/hht2_ep10_timeline_q01_a.c0128b14.png";